module.exports = __webpack_public_path__ + "static/media/manage-auction.ade28a76.svg";